import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import Navbar from "./navbar";
import CartContainer from "../../containers/CartContainer";
import StickyNavbar from "./mobile-sticky-navbar";
import MobileSideNavbar from "./mobile-sidebar";
import MobileMenuToggle from "./mobile-menu-toggle";
import useSWR from "swr";
import { getProfile } from "../../services/index";

import classes from "./css/header-body.module.scss";

import SearchDrawer from "./search-drawer";

import axios from "axios";


const HeaderBody = (props) => {
  const urlParams = new URLSearchParams(window.location.search);
  const { isFixed } = props;

  const [user, setUser] = useState({
    first_name: "",
    last_name: "",
  });
  const [search, setSearch] = useState(urlParams.get("query"));
  const [searchResults, setSearchResults] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const [isSearching, setIsSearching] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [activeUser, setActiveUser] = useState(false);
  const [enableAccountDropdown, setEnableAccountDropdown] = useState(true);

  const [selectedSorting, setSelectedSorting] = useState(
    window.rc.algoliasearch.defaultIndex,
  );

  const profileFetcher = () =>
    getProfile().then((response) =>
      response.data.success === true ? response.data.profile : null
    );

  const { data: profileData } = useSWR(
    localStorage.getItem("user_id") ? "user-profile" : null,
    profileFetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      dedupingInterval: Infinity,
    }
  );

  useEffect(() => {
    if (profileData && profileData.first_name) {
      setUser({
        first_name: profileData.first_name || "",
        last_name: profileData.last_name || "",
      });
      setActiveUser(true);
    } else {
      setActiveUser(false);
    }
  }, [profileData]);

  useEffect(() => {
    const updateAccountMode = () => {
      const supportsHover =
        window.matchMedia &&
        window.matchMedia("(hover: hover) and (pointer: fine)").matches;
      setEnableAccountDropdown(supportsHover && window.innerWidth >= 1200);
    };

    updateAccountMode();
    window.addEventListener("resize", updateAccountMode);
    return () => window.removeEventListener("resize", updateAccountMode);
  }, []);

  const handleSearch = () => {
    axios
      .post(global.postUrl + "restproxy", {
        headers: {
          "X-Algolia-Application-Id": window.rc.algoliasearch.appId,
          "X-Algolia-API-Key": window.rc.algoliasearch.apiKey,
        },
        body: {
          query: search,
          hitsPerPage: 6,
        },
        url:
          "https://" +
          window.rc.algoliasearch.appId +
          "-dsn.algolia.net/1/indexes/" +
          selectedSorting +
          "/query",
        force: false,
      })
      .then((response) => {
        let { hits, nbHits } = response.data.response;

        setSearchResults(hits);
        setTotalProducts(nbHits);
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    if (search) {
      setIsSearching(true);
      const debounceTimer = setTimeout(() => {
        handleSearch(search);
      }, 400);
      return () => clearTimeout(debounceTimer);
    }
  }, [search]);

  useEffect(() => {
    setIsSearching(false);
  }, [searchResults]);

  const searching = (value) => {
    setShowSearchModal(true);
    setSearch(value);
  };

  const accountIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0181 6.57095C15.0181 8.80898 13.2035 10.6224 10.9667 10.6224C8.72865 10.6224 6.91406 8.80898 6.91406 6.57095C6.91406 4.33292 8.72865 2.51953 10.9667 2.51953C13.2035 2.51953 15.0181 4.33292 15.0181 6.57095Z"
        stroke="black"
        strokeLinecap="square"
      />
      <path
        d="M18.3327 19.252C17.3998 16.3017 15.1243 13.586 10.9993 13.586C6.8742 13.586 4.60001 16.2985 3.66602 19.252"
        stroke="black"
        strokeLinecap="square"
      />
    </svg>
  );

  const closeDropdown = (e) => {
    const dropdown = e.target.closest("[data-uk-dropdown]");
    if (dropdown && window.UIkit) {
      window.UIkit.dropdown(dropdown).hide(false);
    }
  };

  const userActive = () => {
    return (
      <div className={classes.dropdown_content}>
        <p className={classes.dropdown_greeting}>{user.first_name}</p>
        <p className={classes.dropdown_desc}>
          Track your Orders, Manage Payment, Edit Profile and much more..
        </p>
        <div className={classes.dropdown_actions}>
          <Link
            to={`${process.env.PUBLIC_URL}/dashboard`}
            className={classes.dropdown_btn_primary}
            onClick={closeDropdown}
          >
            Go to Dashboard
          </Link>
        </div>
      </div>
    );
  };

  const userInActive = () => {
    return (
      <div className={classes.dropdown_content}>
        <p className={classes.dropdown_greeting}>Your Account</p>
        <p className={classes.dropdown_desc}>
          Track your Orders, Manage Payment, Edit Profile and much more..
        </p>
        <div className={classes.dropdown_actions}>
          <Link
            to={`${process.env.PUBLIC_URL}/login`}
            className={classes.dropdown_btn_primary}
            onClick={closeDropdown}
          >
            Log In
          </Link>
          <Link
            to={`${process.env.PUBLIC_URL}/create`}
            className={classes.dropdown_btn_secondary}
            onClick={closeDropdown}
          >
            Sign Up
          </Link>
        </div>
      </div>
    );
  };

  return (
    <div className={`${classes.stickyPanel}`}>
      <MobileSideNavbar />
      <div className={`custom-container ${classes.headerWrap}`}>
        <div className={classes.header}>
          <MobileMenuToggle />
          <div className={classes.logoWrap}>
            {/* Web Logo  */}
            <div className={`${classes.logo} d-xl-block d-none`}>
              <Link to={`${process.env.PUBLIC_URL}/`}>
                {window.logo.desktop.map((data, i) => (
                  <div key={i}>
                    <img
                      className="img-fluid"
                      src={`${process.env.PUBLIC_URL}` + data.image}
                      alt={data.alt}
                      loading="eager"
                    />
                  </div>
                ))}
              </Link>
            </div>
            {/* Mobile Logo  */}
            <div className={`${classes.logo} d-xl-none d-flex`}>
              <Link to={`${process.env.PUBLIC_URL}/`}>
                {window.logo.mobile.map((data, i) => (
                  <div key={i}>
                    <img
                      className="img-fluid"
                      src={`${process.env.PUBLIC_URL}` + data.image}
                      alt={data.alt}
                    />
                  </div>
                ))}
              </Link>
            </div>
          </div>

          <div className={classes.primaryRow}>
            <div className={classes.searchBoxWrap}>
              <div
                className={classes.searchBox}
                onClick={() => setShowSearchModal(true)}
              >
                <span className={classes.searchPlaceholder}>
                  Find the best for you...
                </span>
                <svg
                  className={classes.searchBoxIcon}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <circle
                    cx="9"
                    cy="9"
                    r="6.5"
                    stroke="#000000"
                    strokeWidth="1"
                  />
                  <line
                    x1="13.7"
                    y1="13.7"
                    x2="17.5"
                    y2="17.5"
                    stroke="#000000"
                    strokeWidth="1"
                  />
                </svg>
              </div>

              <div className={classes.searchLinks}>
                <div
                  className={`${classes.utilityItem} ${classes.tabletSearch} uk-flex-inline`}
                  onClick={() => setShowSearchModal(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle
                      cx="10.9963"
                      cy="10.7885"
                      r="8.03854"
                      stroke="black"
                      strokeLinecap="square"
                    />
                    <path
                      d="M16.4859 16.709L21.0394 21.2506"
                      stroke="black"
                      strokeLinecap="square"
                    />
                  </svg>
                </div>
                <div
                  className={`${classes.utilityItem} ${classes.compareIcon} uk-flex-inline`}
                >
                  <Link to={`${process.env.PUBLIC_URL}/compare_list`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                      <rect x="2.80469" y="3.16406" width="5.64017" height="5.64017" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
                      <rect x="13.5586" y="3.16406" width="5.64017" height="5.64017" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
                      <line x1="2.82422" y1="11.5757" x2="19.1787" y2="11.5757" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
                      <path d="M11.0052 12.0757L14.3698 18.7236H7.64062L11.0052 12.0757Z" stroke="black" strokeLinecap="square" strokeLinejoin="round" />
                    </svg>
                  </Link>
                  {(props.compareCount > 0 || props.compareItems.length > 0) && (
                    <span className={classes.utilityCount}>
                      {props.compareCount > 0 ? props.compareCount : props.compareItems.length}
                    </span>
                  )}
                </div>
                <div className={`${classes.utilityItem} uk-flex-inline`}>
                  <Link to={`${process.env.PUBLIC_URL}/wishlists`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="17"
                      viewBox="0 0 18 17"
                      fill="none"
                    >
                      <path
                        d="M17.4582 6.0184C17.4491 3.69386 16.2296 1.50779 13.8252 0.733224C12.1742 0.200446 10.3758 0.496729 8.97913 2.50191C7.58245 0.496729 5.78406 0.200446 4.13308 0.733224C1.72843 1.50788 0.508865 3.69436 0.500044 6.0192C0.477803 10.6426 8.97794 15.8715 8.97794 15.8715L8.97913 15.871L8.98032 15.8715C8.98032 15.8715 17.481 10.6422 17.4582 6.0184Z"
                        stroke="black"
                        strokeLinecap="square"
                      />
                    </svg>
                  </Link>
                  {(props.wishlistCount > 0 || props.wishListItems.length > 0) && (
                    <span className={classes.utilityCount}>
                      {props.wishlistCount > 0 ? props.wishlistCount : props.wishListItems.length}
                    </span>
                  )}
                </div>
                <div className={classes.account}>
                  {enableAccountDropdown ? (
                    <div className="uk-inline">
                      <button
                        className="uk-button uk-button-link uk-padding-remove"
                        type="button"
                      >
                        {accountIcon}
                      </button>
                      <div
                        data-uk-dropdown="boundary:true;pos:bottom-right;delay-hide:200"
                        className=""
                      >
                        {activeUser ? userActive() : userInActive()}
                      </div>
                    </div>
                  ) : (
                    <Link
                      to={`${process.env.PUBLIC_URL}${localStorage.getItem("api_token")
                        ? "/dashboard"
                        : "/login"
                        }`}
                      className="uk-button uk-button-link uk-padding-remove"
                      aria-label={
                        localStorage.getItem("api_token")
                          ? "Go to dashboard"
                          : "Go to login"
                      }
                    >
                      {accountIcon}
                    </Link>
                  )}
                </div>
                <div className={`${classes.cart}`}>
                  <CartContainer />
                </div>
              </div>
            </div>

            <div className={`${classes.secondaryRow} d-none d-xl-flex`}>
              <Navbar
                isFixed={isFixed}
                navBar={props.navBar}
                compareItems={props.compareItems}
              />
            </div>
          </div>
        </div>
      </div>
      <SearchDrawer
        show={showSearchModal}
        onClose={() => {
          setShowSearchModal(false);
          setSearch("");
          setSearchResults([]);
        }}
        search={search}
        onSearchChange={(value) => searching(value)}
        searchResults={searchResults}
        isSearching={isSearching}
        totalProducts={totalProducts}
      />

      {/* Sticky footer navbar  */}

      <StickyNavbar />
    </div>
  );
};

export default HeaderBody;
